import React, { useEffect, useState } from "react";
import { Helmet } from "react-helmet";
import { Link, Redirect } from "react-router-dom";
import { fetchStudioCapabilities } from "../Helper/studioCapabilities";
import {
  availableWorkspaces,
  getWorkspace,
  readStoredWorkspace,
  writeStoredWorkspace,
  workspaceIdFromPortal,
} from "../Workspace/workspaceRegistry";
import "../ContentStudio/ContentStudio.css";

/**
 * /studio — workspace picker / restore. Never lands on Media Library as home.
 */
function StudioLandingPage() {
  const [caps, setCaps] = useState(null);
  const [ready, setReady] = useState(false);

  useEffect(() => {
    let cancelled = false;
    fetchStudioCapabilities().then((c) => {
      if (!cancelled) {
        setCaps(c);
        setReady(true);
      }
    });
    return () => {
      cancelled = true;
    };
  }, []);

  if (!ready) {
    return (
      <div className="cstudio">
        <Helmet>
          <title>Workspace</title>
        </Helmet>
        <p className="cstudio-muted">Loading workspace…</p>
      </div>
    );
  }

  const allowed = availableWorkspaces(caps);
  const stored = readStoredWorkspace();
  if (stored && allowed.some((w) => w.id === stored.workspaceId)) {
    const ws = getWorkspace(stored.workspaceId);
    if (ws) {
      let path = ws.route;
      if (stored.entityId && ws.entityType) {
        path = ws.route + "/" + stored.entityId;
      }
      return <Redirect to={path} />;
    }
  }

  if (allowed.length === 1) {
    const ws = allowed[0];
    let path = ws.route;
    if (ws.entityType === "creator" && caps.creator_ids && caps.creator_ids[0]) {
      path = ws.route + "/" + caps.creator_ids[0];
      writeStoredWorkspace(ws.id, String(caps.creator_ids[0]), null);
    } else if (
      ws.entityType === "organization" &&
      caps.organization_ids &&
      caps.organization_ids[0]
    ) {
      path = ws.route + "/" + caps.organization_ids[0];
      writeStoredWorkspace(ws.id, String(caps.organization_ids[0]), null);
    } else if (
      ws.entityType === "project" &&
      caps.project_ids &&
      caps.project_ids[0]
    ) {
      path = ws.route + "/" + caps.project_ids[0];
      writeStoredWorkspace(ws.id, String(caps.project_ids[0]), null);
    } else {
      writeStoredWorkspace(ws.id, null, null);
    }
    return <Redirect to={path} />;
  }

  const portals = (caps && caps.portals) || [];

  return (
    <div className="cstudio">
      <Helmet>
        <title>Choose workspace</title>
      </Helmet>
      <header className="cstudio__header">
        <div>
          <p className="cstudio-eyebrow">Pentecost+</p>
          <h1>Choose a workspace</h1>
          <p className="cstudio-muted">
            One account · many roles · dedicated dashboards
          </p>
        </div>
      </header>
      <section className="cstudio-panel">
        <ul className="cstudio-list">
          {allowed.map((w) => (
            <li key={w.id}>
              <Link
                className="cstudio-btn"
                to={w.route}
                onClick={() => writeStoredWorkspace(w.id, null, null)}
              >
                {w.displayName}
              </Link>
            </li>
          ))}
        </ul>
        {!allowed.length ? (
          <p className="cstudio-muted">
            No workspaces available.{" "}
            <Link to="/account">Open Account</Link>
          </p>
        ) : null}
        {portals.length ? (
          <p className="cstudio-muted" style={{ marginTop: "1rem" }}>
            Assigned portals:{" "}
            {portals
              .map((p) => p.label || workspaceIdFromPortal(p) || p.role)
              .join(", ")}
          </p>
        ) : null}
      </section>
    </div>
  );
}

export default StudioLandingPage;
